<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Dashboard.scss";
</style>
<template>
  <div>
    <fullscreen ref="fullscreen" @change="fullscreenChange" fullscreen-class="p-10 bg-white">
      <div class="w-full px-6">
          <vs-button @click="toggle" class="p-1" color="white" type="flat">
          <iconBase class="align-middle" iconName="filter_list" :width="28" :height="28" iconColor="#626262">
              <iconFullscreen v-show="!fullscreen"/>
              <iconExitfullscreen v-show="fullscreen"/>
            </iconBase>
            <span v-show="!fullscreen" class="text-grey-dark font-bold align-middle ml-2">{{$t('Labels.Fullscreen')}}</span>
            <span v-show="fullscreen" class="text-grey-dark font-bold align-middle ml-2">{{$t('Labels.ExitFullscreen')}}</span>
          </vs-button>
      </div>
      <div class="w-full font-bold text-2xl my-4" >{{$t('Labels.StatisticsAll')}}</div>
      <div class="w-full sm:w-1/4 p-1 sm:inline-block">
        <vx-card class="p-2 h-full">
          <div class="font-bold my-2 text-center">{{$t('Labels.FailureVoltage')}}</div>
          <vue-apex-charts v-if="isReady" type="radialBar" height="200" :options="chartOptions" :series="voltageSeries"></vue-apex-charts>
        </vx-card>
      </div>
      <div class="w-full sm:w-1/4 p-1 sm:inline-block">
        <vx-card class="p-2 h-full">
          <div class="font-bold my-2 text-center">{{$t('Labels.FailureCurrent')}}</div>
          <vue-apex-charts v-if="isReady" type="radialBar" height="200" :options="chartOptions" :series="currentSeries"></vue-apex-charts>
        </vx-card>
      </div>
      <div class="w-full sm:w-1/4 p-1 sm:inline-block">
        <vx-card class="p-2 h-full">
          <div class="font-bold my-2 text-center">{{$t('Labels.FailureRelay')}}</div>
          <vue-apex-charts v-if="isReady" type="radialBar" height="200" :options="chartOptions" :series="stateSeries"></vue-apex-charts>
        </vx-card>
      </div>
      <div class="w-full sm:w-1/4 p-1 sm:inline-block">
        <vx-card class="p-2 h-full">
          <div class="font-bold my-2 text-center">{{$t('Labels.FailureDimming')}}</div>
          <vue-apex-charts v-if="isReady" type="radialBar" height="200" :options="chartOptions" :series="dimmingSeries"></vue-apex-charts>
        </vx-card>
      </div>
      <div class="container-cards-dashboard">
        <div class="p-1 sum">
          <vx-card class="p-2 h-full">
            <div class="font-bold text-lg mb-4">{{$t('Labels.Summarized')}}</div>
            <div class="p-2 w-full item-summarizado">
              <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" style="background-color:rgb(20 165 255 / 25%)">
                <iconBase iconName="" :width="18" :height="18" iconColor="#14A5FF"><iconCircuit/></iconBase>
              </div>
              <div class="inline-block font-bold align-middle ml-2">
                Total {{$t('Labels.Circuit')+'s'}}
              </div>
              <div class="inline-block float-right align-middle">
                {{global.circuitos || 0}}
              </div>
            </div>
            <div class="p-2 w-full item-summarizado">
              <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" style="background-color:rgb(192 30 232 / 25%)">
                <iconBase iconName="filter_list" :width="18" :height="18" iconColor="#C01EE8"><iconLightMultiple/></iconBase>
              </div>
              <div class="inline-block font-bold ml-2">
                Total {{$t('Labels.Luminaries')}}
              </div>
              <div class="inline-block float-right">
                {{global.total_luminarias || 0}}
              </div>
            </div>
            <div class="p-2 w-full item-summarizado">
              <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" style="background-color:rgb(0 195 195 / 25%)">
                <iconEnergy :width="18" :height="18" iconColor="#00C3C3" :active="true"/>
              </div>
              <div class="inline-block font-bold ml-2">
              {{$t('Labels.ActiveEnergy')}}
              </div>
              <div class="inline-block float-right">
                {{global.acumulado_energia_activa || 0}} <span class="text-primary">Wh</span>
              </div>
            </div>
            <div class="p-2 w-full item-summarizado">
              <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" style="background-color:rgb(12 99 246 / 25%)">
                <iconBase iconName="" :width="18" :height="18" iconColor="#0C63F6"><iconClock/></iconBase>
              </div>
              <div class="inline-block font-bold ml-2">
              {{$t('Labels.Last24Hours')}}
              </div>
              <div class="inline-block float-right">
                {{global.consumo_24hs || 0}} <span class="text-primary">Wh</span>
              </div>
            </div>
            <div class="p-2 w-full item-summarizado">
              <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" style="background-color:rgb(245 236 13 / 25%)">
                <iconBase iconName="filter_list" :width="18" :height="18" iconColor="#F5EC0D"><iconOn/></iconBase>
              </div>
              <div class="inline-block font-bold ml-2">
              {{$t('Labels.On')}}
              </div>
              <div class="inline-block float-right">
                {{global.encendidas || 0}} 
              </div>
            </div>
            <div class="p-2 w-full item-summarizado">
              <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" style="background-color:rgb(255 107 20 / 25%)">
                <iconBase iconName="filter_list" :width="18" :height="18" iconColor="#FF6B14"><iconOff/></iconBase>
              </div>
              <div class="inline-block font-bold ml-2">
              {{$t('Labels.Off')}}
              </div>
              <div class="inline-block float-right ">
                {{global.apagadas || 0}} 
              </div>
            </div>
          </vx-card>
        </div>
        <div class="p-1 values">
          <vx-card class="p-2 h-full">
            <table class="w-full"> 
              <thead>
                <th class="rounded-tl-lg">{{$t('Labels.Value')}}</th>
                <th>{{$t('Labels.Alert')}}</th>
                <th>{{$t('Labels.Average')}}</th>
                <th>{{$t('Labels.Max')}}</th>
                <th class="rounded-tr-lg">{{$t('Labels.Min')}}</th>
              </thead>
              <tbody>
                <tr>
                  <td class="font-bold">
                    <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" style="background-color:rgb(20 165 255 / 25%)">
                      <iconBase iconName="filter_list" :width="18" :height="18" iconColor="#14A5FF"><iconChart/></iconBase>
                    </div>
                    <div  class="inline-block align-middle ml-2">{{$t('Labels.Current')}}</div>
                  </td>
                  <td>{{global.alertas_corriente || 0}}</td>
                  <td>{{(global.promedio_corriente || 0).toFixed(2)}} <span class="text-primary">A</span></td>
                  <td>{{(global.maximo_corriente || 0).toFixed(2)}} <span class="text-primary">A</span></td>
                  <td>{{(global.minimo_corriente || 0).toFixed(2)}} <span class="text-primary">A</span></td>
                </tr>
                <tr>
                  <td class="font-bold">
                    <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" style="background-color:rgb(192 30 232 / 25%)">
                      <iconBase iconName="filter_list" :width="18" :height="18" iconColor="#C01EE8"><iconChart/></iconBase>
                    </div>
                    <div class="inline-block align-middle ml-2">{{$t('Labels.ActivePower')}}</div>
                  </td>
                  <td>{{global.alertas_potencia || 0}}</td>
                  <td>{{(global.promedio_potencia || 0).toFixed(2)}} <span class="text-primary">W</span></td>
                  <td>{{(global.maximo_potencia || 0).toFixed(2)}} <span class="text-primary">W</span></td>
                  <td>{{(global.minimo_potencia || 0).toFixed(2)}} <span class="text-primary">W</span></td>
                </tr>
                <tr>
                  <td class="font-bold">
                    <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" style="background-color:rgb(0 195 195 / 25%)">
                      <iconBase iconName="filter_list" :width="18" :height="18" iconColor="#00C3C3"><iconChart/></iconBase>
                    </div>
                    <div class="inline-block align-middle ml-2">{{$t('Labels.ReactivePower')}}</div>
                  </td>
                  <td>{{global.alertas_potencia_reactiva || 0}}</td>
                  <td>{{(global.promedio_potencia_reactiva || 0).toFixed(2)}}  <span class="text-primary">VAR</span></td>
                  <td>{{(global.maximo_potencia_reactiva || 0).toFixed(2)}}  <span class="text-primary">VAR</span></td>
                  <td>{{(global.minimo_potencia_reactiva || 0).toFixed(2)}}  <span class="text-primary">VAR</span></td>
                </tr>
                <tr>
                  <td class="font-bold">
                    <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" style="background-color:rgb(245 236 13 / 25%)">
                      <iconBase iconName="filter_list" :width="18" :height="18" iconColor="#F5EC0D"><iconChart/></iconBase>
                    </div>
                    <div class="inline-block align-middle ml-2">{{$t('Labels.ApparentPower')}}</div>
                  </td>
                  <td>{{global.alertas_potencia_aparente || 0}}</td>
                  <td>{{(global.promedio_potencia_aparente || 0).toFixed(2)}} <span class="text-primary">VA</span></td>
                  <td>{{(global.maximo_potencia_aparente || 0).toFixed(2)}} <span class="text-primary">VA</span></td>
                  <td>{{(global.minimo_potencia_aparente || 0).toFixed(2)}} <span class="text-primary">VA</span></td>
                </tr>
                <tr>
                  <td class="font-bold">
                    <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" style="background-color:rgb(245 236 13 / 25%)">
                      <iconBase iconName="filter_list" :width="18" :height="18" iconColor="#FF6B14"><iconChart/></iconBase>
                    </div>
                    <div class="inline-block align-middle ml-2">{{$t('Labels.PowerFactor')}}</div>
                  </td>
                  <td>{{global.alertas_factor_potencia || 0}}</td>
                  <td>{{(global.promedio_factor_potencia || 0).toFixed(2)}}</td>
                  <td>{{(global.maximo_factor_potencia || 0).toFixed(2)}}</td>
                  <td>{{(global.minimo_factor_potencia || 0).toFixed(2)}}</td>
                </tr>
                <tr>
                  <td class="font-bold">
                    <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" style="background-color:rgb(12 99 246 / 25%)">
                      <iconBase iconName="filter_list" :width="18" :height="18" iconColor="#0C63F6"><iconChart/></iconBase>
                    </div>
                    <div class="inline-block align-middle ml-2">{{$t('Labels.Frequency')}}</div>
                  </td>
                  <td>{{global.alertas_frecuencia || 0}}</td>
                  <td>{{(global.promedio_frecuencia || 0).toFixed(2)}} <span class="text-primary">Hz</span></td>
                  <td>{{(global.maximo_frecuencia || 0).toFixed(2)}} <span class="text-primary">Hz</span></td>
                  <td>{{(global.minimo_frecuencia || 0).toFixed(2)}} <span class="text-primary">Hz</span></td>
                </tr>
                <tr>
                  <td class="font-bold">
                    <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" style="background-color:rgb(184 252 8 / 25%)">
                      <iconBase iconName="filter_list" :width="18" :height="18" iconColor="#B8FC08"><iconChart/></iconBase>
                    </div>
                    <div class="inline-block align-middle ml-2">{{$t('Labels.Dimming')}}</div>
                  </td>
                  <td>N/A</td>
                  <td>{{(global.promedio_intensidad || 0).toFixed(2)}}</td>
                  <td>{{(global.maximo_intensidad || 0).toFixed(2)}}</td>
                  <td>{{(global.minimo_intensidad || 0).toFixed(2)}}</td>
                </tr>
              </tbody>
            </table>
          </vx-card>
        </div>
      </div>
      <div v-for="(item,index) in circuits" :key="item.objectID">
        <div class="w-full font-bold text-2xl my-4" >{{$t('Labels.StatisticsCircuit') +': '+ (item.name || $t('Labels.NotAssignedToCircuit'))}}</div>
        <div class="w-full sm:w-1/4 p-1 sm:inline-block" v-if="item.total_luminarias > 0">
          <vx-card class=" h-full">
            <div class="font-bold my-2 text-center">{{$t('Labels.FailureVoltage')}}</div>
            <vue-apex-charts v-if="isReadyCircuits" type="radialBar" height="200" :options="chartOptions" :series="seriesCircuits[index][0]"></vue-apex-charts>
          </vx-card>
        </div>
        <div class="w-full sm:w-1/4 p-1 sm:inline-block" v-if="item.total_luminarias > 0">
          <vx-card class=" h-full">
            <div class="font-bold my-2 text-center">{{$t('Labels.FailureCurrent')}}</div>
            <vue-apex-charts v-if="isReadyCircuits" type="radialBar" height="200" :options="chartOptions" :series="seriesCircuits[index][1]"></vue-apex-charts>
          </vx-card>
        </div>
        <div class="w-full sm:w-1/4 p-1 sm:inline-block" v-if="item.total_luminarias > 0">
          <vx-card class=" h-full">
            <div class="font-bold my-2 text-center">{{$t('Labels.FailureRelay')}}</div>
            <vue-apex-charts v-if="isReadyCircuits" type="radialBar" height="200" :options="chartOptions" :series="seriesCircuits[index][2]"></vue-apex-charts>
          </vx-card>
        </div>
        <div class="w-full sm:w-1/4 p-1 sm:inline-block" v-if="item.total_luminarias > 0">
          <vx-card class=" h-full">
            <div class="font-bold my-2 text-center">{{$t('Labels.FailureDimming')}}</div>
            <vue-apex-charts v-if="isReadyCircuits" type="radialBar" height="200" :options="chartOptions" :series="seriesCircuits[index][3]"></vue-apex-charts>
          </vx-card>
        </div>
        <div class="container-cards-dashboard">
          <div class="p-1 sum">
            <vx-card class="p-2 h-full">
              <div class="font-bold text-lg mb-4">{{$t('Labels.Summarized')}}</div>
              <div class="p-2 w-full item-summarizado hover:bg-grey-light">
                <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" style="background-color:rgb(192 30 232 / 25%)">
                  <iconBase iconName="filter_list" :width="18" :height="18" iconColor="#C01EE8"><iconLightMultiple/></iconBase>
                </div>
                <div class="inline-block font-bold ml-2">
                  Total {{$t('Labels.Luminaries')}}
                </div>
                <div class="inline-block float-right">
                  {{item.total_luminarias || 0}}
                </div>
              </div>
              <div class="p-2 w-full item-summarizado">
                <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" style="background-color:rgb(0 195 195 / 25%)">
                  <iconEnergy :width="18" :height="18" iconColor="#00C3C3" :active="true"/>
                </div>
                <div class="inline-block font-bold ml-2">
                {{$t('Labels.ActiveEnergy')}}
                </div>
                <div class="inline-block float-right">
                  {{item.acumulado_energia_activa || 0}} <span class="text-primary">Wh</span>
                </div>
              </div>
              <div class="p-2 w-full item-summarizado">
                <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" style="background-color:rgb(12 99 246 / 25%)">
                  <iconBase iconName="" :width="18" :height="18" iconColor="#0C63F6"><iconClock/></iconBase>
                </div>
                <div class="inline-block font-bold ml-2">
                {{$t('Labels.Last24Hours')}}
                </div>
                <div class="inline-block float-right">
                  {{item.consumo_24hs || 0}} <span class="text-primary">Wh</span>
                </div>
              </div>
              <div class="p-2 w-full item-summarizado">
                <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" style="background-color:rgb(245 236 13 / 25%)">
                  <iconBase iconName="filter_list" :width="18" :height="18" iconColor="#F5EC0D"><iconOn/></iconBase>
                </div>
                <div class="inline-block font-bold ml-2">
                {{$t('Labels.On')}}
                </div>
                <div class="inline-block float-right">
                  {{item.encendidas || 0}} 
                </div>
              </div>
              <div class="p-2 w-full item-summarizado">
                <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" style="background-color:rgb(255 107 20 / 25%)">
                  <iconBase iconName="filter_list" :width="18" :height="18" iconColor="#FF6B14"><iconOff/></iconBase>
                </div>
                <div class="inline-block font-bold ml-2">
                {{$t('Labels.Off')}}
                </div>
                <div class="inline-block float-right ">
                  {{item.apagadas || 0}} 
                </div>
              </div>
            </vx-card>
          </div>
          <div class="p-1 values">
            <vx-card class="p-2 h-full">
              <table class="w-full"> 
                <thead>
                  <th class="rounded-tl-lg">{{$t('Labels.Value')}}</th>
                  <th>{{$t('Labels.Alert')}}</th>
                  <th>{{$t('Labels.Average')}}</th>
                  <th>{{$t('Labels.Max')}}</th>
                  <th class="rounded-tr-lg">{{$t('Labels.Min')}}</th>
                </thead>
                <tbody>
                  <tr>
                    <td class="font-bold">
                      <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" style="background-color:rgb(20 165 255 / 25%)">
                        <iconBase iconName="filter_list" :width="18" :height="18" iconColor="#14A5FF"><iconChart/></iconBase>
                      </div>
                      <div  class="inline-block align-middle ml-2">{{$t('Labels.Current')}}</div>
                    </td>
                    <td>{{item.alertas_corriente || 0}}</td>
                    <td>{{(item.promedio_corriente || 0).toFixed(2)}} <span class="text-primary">A</span></td>
                    <td>{{(item.maximo_corriente || 0).toFixed(2)}} <span class="text-primary">A</span></td>
                    <td>{{(item.minimo_corriente || 0).toFixed(2)}} <span class="text-primary">A</span></td>
                  </tr>
                  <tr>
                    <td class="font-bold">
                      <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" style="background-color:rgb(192 30 232 / 25%)">
                        <iconBase iconName="filter_list" :width="18" :height="18" iconColor="#C01EE8"><iconChart/></iconBase>
                      </div>
                      <div class="inline-block align-middle ml-2">{{$t('Labels.ActivePower')}}</div>
                    </td>
                    <td>{{item.alertas_potencia || 0}}</td>
                    <td>{{(item.promedio_potencia || 0).toFixed(2)}} <span class="text-primary">W</span></td>
                    <td>{{(item.maximo_potencia || 0).toFixed(2)}} <span class="text-primary">W</span></td>
                    <td>{{(item.minimo_potencia || 0).toFixed(2)}} <span class="text-primary">W</span></td>
                  </tr>
                  <tr>
                    <td class="font-bold">
                      <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" style="background-color:rgb(0 195 195 / 25%)">
                        <iconBase iconName="filter_list" :width="18" :height="18" iconColor="#00C3C3"><iconChart/></iconBase>
                      </div>
                      <div class="inline-block align-middle ml-2">{{$t('Labels.ReactivePower')}}</div>
                    </td>
                    <td>{{item.alertas_potencia_reactiva || 0}}</td>
                    <td>{{(item.promedio_potencia_reactiva || 0).toFixed(2)}}  <span class="text-primary">VAR</span></td>
                    <td>{{(item.maximo_potencia_reactiva || 0).toFixed(2)}}  <span class="text-primary">VAR</span></td>
                    <td>{{(item.minimo_potencia_reactiva || 0).toFixed(2)}}  <span class="text-primary">VAR</span></td>
                  </tr>
                  <tr>
                    <td class="font-bold">
                      <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" style="background-color:rgb(245 236 13 / 25%)">
                        <iconBase iconName="filter_list" :width="18" :height="18" iconColor="#F5EC0D"><iconChart/></iconBase>
                      </div>
                      <div class="inline-block align-middle ml-2">{{$t('Labels.ApparentPower')}}</div>
                    </td>
                    <td>{{item.alertas_potencia_aparente || 0}}</td>
                    <td>{{(item.promedio_potencia_aparente || 0).toFixed(2)}} <span class="text-primary">VA</span></td>
                    <td>{{(item.maximo_potencia_aparente || 0).toFixed(2)}} <span class="text-primary">VA</span></td>
                    <td>{{(item.minimo_potencia_aparente || 0).toFixed(2)}} <span class="text-primary">VA</span></td>
                  </tr>
                  <tr>
                    <td class="font-bold">
                      <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" style="background-color:rgb(245 236 13 / 25%)">
                        <iconBase iconName="filter_list" :width="18" :height="18" iconColor="#FF6B14"><iconChart/></iconBase>
                      </div>
                      <div class="inline-block align-middle ml-2">{{$t('Labels.PowerFactor')}}</div>
                    </td>
                    <td>{{item.alertas_factor_potencia || 0}}</td>
                    <td>{{(item.promedio_factor_potencia || 0).toFixed(2)}}</td>
                    <td>{{(item.maximo_factor_potencia || 0).toFixed(2)}}</td>
                    <td>{{(item.minimo_factor_potencia || 0).toFixed(2)}}</td>
                  </tr>
                  <tr>
                    <td class="font-bold">
                      <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" style="background-color:rgb(12 99 246 / 25%)">
                        <iconBase iconName="filter_list" :width="18" :height="18" iconColor="#0C63F6"><iconChart/></iconBase>
                      </div>
                      <div class="inline-block align-middle ml-2">{{$t('Labels.Frequency')}}</div>
                    </td>
                    <td>{{item.alertas_frecuencia || 0}}</td>
                    <td>{{(item.promedio_frecuencia || 0).toFixed(2)}} <span class="text-primary">Hz</span></td>
                    <td>{{(item.maximo_frecuencia || 0).toFixed(2)}} <span class="text-primary">Hz</span></td>
                    <td>{{(item.minimo_frecuencia || 0).toFixed(2)}} <span class="text-primary">Hz</span></td>
                  </tr>
                  <tr>
                    <td class="font-bold">
                      <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" style="background-color:rgb(184 252 8 / 25%)">
                        <iconBase iconName="filter_list" :width="18" :height="18" iconColor="#B8FC08"><iconChart/></iconBase>
                      </div>
                      <div class="inline-block align-middle ml-2">{{$t('Labels.Dimming')}}</div>
                    </td>
                    <td>N/A</td>
                    <td>{{(item.promedio_intensidad || 0).toFixed(2)}}</td>
                    <td>{{(item.maximo_intensidad || 0).toFixed(2)}}</td>
                    <td>{{(item.minimo_intensidad || 0).toFixed(2)}}</td>
                  </tr>
                </tbody>
              </table>
            </vx-card>
          </div>
        </div>
      </div>
    </fullscreen>
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
import {request} from '@/request.js'
import fullscreen from 'vue-fullscreen/src/component.vue'
import iconBase from '@/components/icons/iconBase'
import iconFullscreen from '@/components/icons/iconFullscreen'
import iconExitfullscreen from '@/components/icons/iconExitfullscreen'
import statistics from '@/components/statistics/statistics.vue'
import itemDashboard from '@/components/itemDashboard/itemDashboard.vue'
import iconCircuit from '@/components/icons/iconCircuit'
import iconOn from '@/components/icons/iconOn'
import iconOff from '@/components/icons/iconOff'
import iconEnergy from '@/components/icons/iconEnergy'
import iconLightMultiple from '@/components/icons/iconLightMultiple'
import iconChart from '@/components/icons/iconChart'
import iconClock from '@/components/icons/iconClock'

export default {
  components: {
    VueApexCharts,
    fullscreen,
    iconBase,
    iconFullscreen,
    iconExitfullscreen,
    statistics,
    itemDashboard,
    iconCircuit,
    iconOff,
    iconOn,
    iconEnergy,
    iconLightMultiple,
    iconChart,
    iconClock
  },
  data () {
    return {
      trigoStrength: 3,
      isReady: false,
      fullscreen: false,
      global:{},
      chartOptions: {
        colors: ['#4dc770'],
        labels: [this.$t('Labels.NoError')]
      },
      voltageSeries: [0, 0],
      currentSeries: [0, 0],
      stateSeries: [0, 0],
      dimmingSeries: [0, 0],
      circuits: [],
      isReadyCircuits: false,
      seriesCircuits: []
    }
  },
  methods: {
    toggle () {
      this.$refs['fullscreen'].toggle() 
    },
    fullscreenChange (fullscreen) {
      this.fullscreen = fullscreen
    },
    async getDashboard () {
      this.$vs.loading()
      const params = {
        url: 'luminaires_devices/dashboard_global',
        method: 'GET',
        params: {}
      }
      await request(params).then(response => {
        this.global = response.data.data
        const total = response.data.data.total_luminarias
        this.voltageSeries = [Math.ceil(this.global.error_voltaje_0 * 100 / total)]
        this.currentSeries = [Math.ceil(this.global.error_current_0 * 100 / total)]
        this.stateSeries = [Math.ceil(this.global.error_state_0 * 100 / total)]
        this.dimmingSeries = [Math.ceil(this.global.error_dimming_0 * 100 / total)]
        this.isReady = true
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    async getDashboardCircuits () {
      this.$vs.loading()
      const params = {
        url: 'luminaires_devices/dashboard_circuits',
        method: 'GET',
        params: {}
      }
      await request(params).then(response => {
        this.circuits = response.data.data
        this.isReadyCircuits = true
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    async getCircuits () {
      this.$vs.loading()
      const params = {
        url: 'luminaires_devices/dashboard_circuits',
        method: 'GET',
        params: {}
      }
      await request(params).then(response => {
        this.circuits = response.data.data
        this.circuits.forEach((element) => {
          const total = element.total_luminarias
          const aux = []
          if (element.error_voltaje_0 === 0 && total === 0) {
            aux[0] = [100]
          } else if (element.error_voltaje_0 === 0 && total !== 0) {
            aux[0] = [0]
          } else {
            aux[0] = [Math.ceil(element.error_voltaje_0 * 100 / total)]
          }

          if (element.error_current_0 === 0 && total === 0) {
            aux[1] = [100]
          } else if (element.error_current_0 === 0 && total !== 0) {
            aux[1] = [0]
          } else {
            aux[1] = [Math.ceil(element.error_current_0 * 100 / total)]
          }

          if (element.error_state_0 === 0 && total === 0) {
            aux[2] = [100]
          } else if (element.error_state_0 === 0 && total !== 0) {
            aux[2] = [0]
          } else {
            aux[2] = [Math.ceil(element.error_state_0 * 100 / total)]
          }

          if (element.error_dimming_0 === 0 && total === 0) {
            aux[3] = [100]
          } else if (element.error_dimming_0 === 0 && total !== 0) {
            aux[3] = [0]
          } else {
            aux[3] = [Math.ceil(element.error_dimming_0 * 100 / total)]
          }

          this.seriesCircuits.push(aux)
        })
        this.isReadyCircuits = true
      }).finally(() => {
        this.$vs.loading.close()
      })
    }
  },
  mounted () {
    this.getDashboard()
    this.getCircuits()
  }
}
</script>